export const postLimit = 150;

export const emojis = [
  "🎉",
  "😂",
  "😎",
  "😜",
  "😲",
  "😦",
  "😷",
  "🤓",
  "🚀",
  "⚛",
  "🙂",
  "🥳",
  "👋",
  "✌🏼",
  "😁",
  "💸",
  "🔥",
  "😯",
  "🤔",
  "✨",
  "👏",
  "💯",
  "🎈",
  "👀",
];
